/*
 * @Author: luoziyan 365977508@qq.com
 * @Date: 2022-08-19 14:24:19
 * @LastEditors: luoziyan 365977508@qq.com
 * @LastEditTime: 2024-04-22 16:03:40
 * @FilePath: \lehome-central\src\main\webapp\app\app.tsx
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import { ConfigProvider } from 'antd';
import React, { useEffect } from 'react';
import { hot } from 'react-hot-loader';
import { connect } from 'react-redux';
import { BrowserRouter as Router } from 'react-router-dom';
import './app.scss';

import enUS from 'antd/lib/locale-provider/en_US';
import zhCN from 'antd/lib/locale-provider/zh_CN';
import { getEntities } from 'app/entities/house/house.reducer';
import AppRoutes from 'app/routes';
import { hasAnyAuthority } from 'app/shared/auth/private-route';
import ErrorBoundary from 'app/shared/error/error-boundary';
import { IRootState } from 'app/shared/reducers';
import { getProfile } from 'app/shared/reducers/application-profile';
import { getSession } from 'app/shared/reducers/authentication';
import moment from 'moment';

const baseHref = document
  .querySelector('base')
  .getAttribute('href')
  .replace(/\/$/, '');

export interface IAppProps extends StateProps, DispatchProps {}

export const App = (props: IAppProps) => {
  useEffect(() => {
    props.getSession(); // 权限
    props.getEntities(0, 20, '', { buildingType: { equals: 'CENTRALIZED' } }); // 请求集中式房源
    // props.getProfile();
  }, []);

  let currentLocale: any = zhCN;
  moment.locale('zh-cn');
  if (props.currentLocale === 'en') {
    currentLocale = enUS;
    moment.locale('en');
  }

  return (
    <ConfigProvider locale={currentLocale}>
      <Router basename={baseHref}>
        <ErrorBoundary>
          <AppRoutes />
        </ErrorBoundary>
      </Router>
    </ConfigProvider>
  );
};

const mapStateToProps = ({ locale, authentication }: IRootState) => ({
  isAuthenticated: authentication.isAuthenticated,
  currentLocale: locale.currentLocale
});

const mapDispatchToProps = { getSession, getEntities, getProfile, hasAnyAuthority };

type StateProps = ReturnType<typeof mapStateToProps>;
type DispatchProps = typeof mapDispatchToProps;

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(hot(module)(App));
